import { render } from "./Sv024.vue?vue&type=template&id=cf86a6d0&scoped=true"
import script from "./Sv024.vue?vue&type=script&lang=js"
export * from "./Sv024.vue?vue&type=script&lang=js"

import "./Sv024.vue?vue&type=style&index=0&id=cf86a6d0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf86a6d0"]])

export default __exports__